import { supabase } from "@/integrations/supabase/client";

/**
 * Active Terms & Waiver version. Must stay in sync with the SQL function
 * `current_terms_version()` and the version rendered on the /terms page.
 */
export const CURRENT_TERMS_VERSION = "2026-07-22";

/**
 * Record the signed-in user's acceptance of the current Terms & Waiver version.
 * Requires the medical-fitness self-certification. Returns the accepted version.
 */
export async function acceptCurrentTerms(healthConfirmed: boolean): Promise<string> {
  const { data, error } = await supabase.rpc("accept_current_terms", {
    p_health_confirmed: healthConfirmed,
  });
  if (error) throw error;
  return data as string;
}

/** Whether the signed-in user has self-accepted the current Terms & Waiver version. */
export async function hasAcceptedCurrentTerms(): Promise<boolean> {
  const { data, error } = await supabase.rpc("has_accepted_current_terms");
  if (error) throw error;
  return Boolean(data);
}
